export default __webpack_public_path__ + "static/media/shannel2.610ae0ce.jpg";